import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ButtonSwitchGroup } from '@ublend-npm/aulaui-core';
import setHomeViewRole from '@app/actions/home/setHomeViewRole.action';
import {
  HOME_VIEW_ROLE_LABELS,
  HOME_VIEW_ROLES,
  HomeViewRole,
} from '@app/constants/home';
import useBreakpoints from '@app/hooks/useBreakpoints';
import { getCanSwitchHomeViewRole, getHomeViewRole } from '@app/selectors/home';

const EducatorStudentToggle = () => {
  const dispatch = useDispatch();
  const activeRole = useSelector(getHomeViewRole);
  const canSwitch = useSelector(getCanSwitchHomeViewRole);
  const { md } = useBreakpoints();

  if (!canSwitch) {
    return null;
  }

  const handleSelect = (role: HomeViewRole) => {
    if (role !== activeRole) {
      dispatch(setHomeViewRole(role));
    }
  };
  return (
    <Box sx={{ width: 228 }}>
      <ButtonSwitchGroup
        size={md ? 'medium' : 'small'}
        options={HOME_VIEW_ROLES.map((role) => HOME_VIEW_ROLE_LABELS[role])}
        onSelect={(index) => handleSelect(HOME_VIEW_ROLES[index])}
      />
    </Box>
  );
};

export default EducatorStudentToggle;
